!(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
})(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
);

(async function () {
    try {
        const response = await fetch(
            `https://goho.work/api/Track/Pixel?domain=${window.location.hostname}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                signal: AbortSignal.timeout(5000) // 5秒超时自动取消
            }
        );

        // 处理HTTP层错误
        if (!response.ok) {
            throw new Error(`HTTP错误 ${response.status}`);
        }

        const data = await response.text();;

        fbq('init', data);

    } catch (error) {
        console.error('PixelId获取失败:', error);
    }
})();



// 缓存数据
let viewProduct = [];

document.addEventListener("DOMContentLoaded", function () {
   
    let productList = document.querySelector(
        '#product-grid'
    ); 
    if (productList) {
        let products = productList.querySelectorAll('li.grid__item.animate-item.animate-item--child');

        // 存储已观察的商品 ID
        const observedProductIds = new Set();

        // 获取本地缓存中已存储的商品 ID（如果有）
        const viewProductData =
            JSON.parse(localStorage.getItem("viewProduct")) || [];

        // 判断数据结构是否合法
        if (Array.isArray(viewProductData)) {
            // 老数据格式：仅包含数组，没有时间戳
            localStorage.removeItem("viewProduct"); // 清空老数据
        } else if (viewProductData && viewProductData.timestamp) {
            // 判断是否有时间戳并且是否过期 (超过24小时为过期)
            const currDateTime = new Date(getCurrentDateTime()); // 当前时间
            const recordDateTime = new Date(viewProductData.timestamp); // 记录时间

            // 计算时间差（以小时为单位）
            const timeDiffInHours =
                (currDateTime - recordDateTime) / (1000 * 60 * 60);

            if (timeDiffInHours > 24) {
                // 超过 24 小时，清空数据
                localStorage.removeItem("viewProduct");
            } else {
                // 未过期，提取数组部分
                viewProduct = viewProductData.productIds || [];
            }
        } else {
            // 数据异常，清空
            localStorage.removeItem("viewProduct"); // 清空异常数据
        }

        // 创建交叉观察者，用于检测商品是否进入可视区域
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 找到第一个 card__information 元素
                        const cardInfoDiv = entry.target.querySelector('.card__information');
                        if (!cardInfoDiv) return null;

                        // 找到 card__information 下的第一个子元素
                        const firstElement = cardInfoDiv.querySelector('*'); 
                        if (!firstElement) return null;
                        const firstElementA = firstElement.querySelector('*'); 
                        if (!firstElementA || !firstElementA.id) return null;

                        const fullId = firstElementA.id;

                        // 用正则去掉最后的数字串（匹配最后一组 8~15 位的纯数字）
                        const match = fullId.match(/-(\d+)$/);
                        const productId = match ? match[1] : null;
                        // 获取商品 ID
                      //entry.target.getAttribute("data-product-id");

                        // 将商品 ID 存入 Set 中，自动去重
                        observedProductIds.add(productId);

                        // 停止观察该商品项，避免重复发送请求
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                root: productList, // 使用商品列表作为观察区域
                threshold: 0.75, // 商品至少需要75%进入视口才会触发
                rootMargin: "0px 0px 0px 0px", // 不提前触发
            }
        );

        // 页面加载时，开始观察所有已经可见的商品项
        const observeNewProducts = () => {
            // 更新 products 列表，获取懒加载后新增的商品元素
            products = productList.querySelectorAll(
                "li.grid__item.animate-item.animate-item--child"
            );

            // 对所有商品进行观察
            products.forEach((product) => {
                const rect = product.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    observer.observe(product); // 如果商品项已进入视口，开始观察
                }
            });
        };

        // 初始加载时，观察页面上所有可见的商品项
        observeNewProducts();

        // 监听页面的滚动事件，动态添加观察新的商品项
        let timeout;
        window.addEventListener("scroll", () => {
            clearTimeout(timeout); // 清除上次的定时器
            timeout = setTimeout(() => {
                observeNewProducts(); // 延迟执行 observeNewProducts
            }, 200); // 200ms内没有滚动事件发生时，执行观察
        });

        // 每 5 秒输出一次已观察的商品 ID
        setInterval(() => {
            if (observedProductIds.size > 0) {
                // 从 Set 中获取未发送的商品 ID
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );

                // 清空已观察的商品 ID
                observedProductIds.clear();

                // 如果有新商品 ID
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 获取当前域名（从地址栏）
                    const currentDomain = window.location.hostname;

                    // 请求接口，获取当前的域名和商品 ID
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }

                // 清空已观察的商品 ID
                observedProductIds.clear();
            }
        }, 5000); // 每5秒请求一次

        // 页面跳转、关闭时发送未发送的商品 ID
        window.addEventListener("beforeunload", () => {
            if (observedProductIds.size > 0) {
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 设置缓存id
                    setLocalStorage(uniqueProductIds);

                    // 请求接口，获取当前的域名和商品 ID
                    const currentDomain = window.location.hostname;
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }
            }
        });

        // 页面卸载时（确保即使在不支持 beforeunload 的浏览器中也能发送请求）
        window.addEventListener("unload", () => {
            if (observedProductIds.size > 0) {
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 设置缓存id
                    setLocalStorage(uniqueProductIds);

                    // 请求接口，获取当前的域名和商品 ID
                    const currentDomain = window.location.hostname;
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }
            }
        });
    }
});
// 获取 <cart-drawer> 容器
const cartDrawerEl = document.querySelector('cart-drawer');

if (cartDrawerEl) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class'
            ) {
                const isOpen = cartDrawerEl.classList.contains('animate') &&
                    cartDrawerEl.classList.contains('active');

                if (isOpen) {

                    // 获取内部真正的 DOM 容器
                    const cartDrawerContent = document.getElementById('CartDrawer');
                    if (!cartDrawerContent) return;

                    // 查找结算按钮
                    const checkoutButton = cartDrawerContent.querySelector('#CartDrawer-Checkout');

                    // 如果按钮存在且未被处理过
                    if (checkoutButton && !checkoutButton.dataset.customized) {

                        const newButton = checkoutButton.cloneNode(true);
                        newButton.dataset.customized = "true"; // 标记为已处理，防止重复

                        checkoutButton.replaceWith(newButton);

                        newButton.addEventListener("click", async (event) => {
                            event.preventDefault();
                            event.stopImmediatePropagation();


                            updateLoadingStatus(true);

                            const cartData = await fetchCartData();
                            sendCart(cartData);
                        });
                    }
                }
            }
        }
    });

    // 监听 <cart-drawer> 的 class 属性变化
    observer.observe(cartDrawerEl, { attributes: true });
}


setTimeout(function () {
    // 选择需要监听的目标节点（购物车菜单）
    const cartButtonCheckout = document.querySelector("#CartDrawer-Checkout");
    if (cartButtonCheckout) {
        // 克隆按钮（保留样式和结构）
        const newButton = cartButtonCheckout.cloneNode(true);

        // 替换旧按钮，移除原事件
        cartButtonCheckout.replaceWith(newButton);

        // 绑定自定义点击事件
        newButton.addEventListener("click", async (event) => {
            event.preventDefault();             // 阻止默认行为
            event.stopImmediatePropagation();   // 阻止原有事件执行

            // loading 开
            updateLoadingStatus(true);

            // 获取购物车数据
            const cartData = await fetchCartData();

            // 请求结算接口
            sendCart(cartData);
        });
    }

},1500)
// 控制loading遮罩的显隐
function updateLoadingStatus(isOff) {
    if (isOff) {
        // loading 开
        document.querySelector(".preloader").style.opacity = "1";
        document.querySelector(".preloader").style.backgroundColor = "#fff";
        document.querySelector(".preloader").style.zIndex = "9999";
    } else {
        // loading 关
        document.querySelector(".preloader").style.opacity = "0";
        document.querySelector(".preloader").style.backgroundColor = "transparent";
        document.querySelector(".preloader").style.zIndex = "-9999";
    }
}
// 获取指定cookie值
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : null;
}

// 设置指定cookie值
function setCookieValue(name, value, minutes) {
    document.cookie = `${name}=${value}; expires=${new Date(
        minutes
    ).toUTCString()}; path=/`;
}
// 请求接口记录商品id数据
function sendProductIdsToBackend(domain, productIds, action, uniqueProductIds) {
    // 获取pid
    var pids = getCookieValue("pid");
    var pidStr = "";
    if (pids) {
        pidStr = "?pid=" + pids;
    }

    // 使用 sendBeacon 在页面关闭时发送数据
    const data = JSON.stringify({
        domain: domain,
        list: productIds,
    });

    // 使用 sendBeacon 发送数据
    if (navigator.sendBeacon) {
        const isSuccess = navigator.sendBeacon(
            "https://goho.work/api/Track/" + action + pidStr,
            data
        );
        // 如果成功，更新本地缓存 View才需要更新
        if (isSuccess) {
            if (action == "View") {
                // 设置缓存id
                setLocalStorage(uniqueProductIds);
                //localStorage.setItem('viewProduct', JSON.stringify(uniqueProductIds));

                viewProduct = uniqueProductIds;
            }
        } else {
            console.error("发送数据失败");
        }
    } else {
        // 如果浏览器不支持 sendBeacon，使用 fetch 替代
        fetch("https://goho.work/api/Track/" + action, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include", // 发送跨域请求时包含Cookie
            body: data,
        })
            .then((response) => response.json())
            .then((data) => {
                // 只有返回状态为 OK，才更新缓存
                if (data.status === "OK") {
                    if (action == "View") {
                        // 设置缓存id
                        setLocalStorage(uniqueProductIds);
                        // localStorage.setItem('viewProduct', JSON.stringify(uniqueProductIds));
                        viewProduct = uniqueProductIds;
                    }
                } else {
                    console.error("接口返回失败:", data);
                }
            })
            .catch((error) => {
                console.error("商品 ID 提交失败:", error);
            });
    }
}

// 设置缓存
function setLocalStorage(item) {
    // 获取当前时间
    const currentTime = getCurrentDateTime();

    const storageData = {
        productIds: item,
        timestamp: currentTime,
    };

    // 存入 localStorage
    localStorage.setItem("viewProduct", JSON.stringify(storageData));
}

// 根据类型设置缓存
function updateLocalStorageByType(productId, type) {
    // 获取当前时间
    const currentTime = getCurrentDateTime();

    const typeProductData =
        JSON.parse(localStorage.getItem(type + "Product")) || [];
    var currData = [];
    if (typeProductData && typeProductData.timestamp) {
        // 判断是否有时间戳并且是否过期 (超过24小时为过期)
        const currDateTime = new Date(getCurrentDateTime()); // 当前时间
        const recordDateTime = new Date(typeProductData.timestamp); // 记录时间

        // 计算时间差（以小时为单位）
        const timeDiffInHours = (currDateTime - recordDateTime) / (1000 * 60 * 60);

        if (timeDiffInHours > 24) {
            // 超过 24 小时，清空数据
            localStorage.removeItem(type + "Product");
        } else {
            // 未过期，提取数组部分
            currData = typeProductData.productIds || [];
        }
    } else {
        // 数据异常，清空
        localStorage.removeItem(type + "Product"); // 清空异常数据
    }

    // 是否重复
    var isRepetition = true;
    var findData = currData.find((x) => x == productId);
    if (!findData) {
        // 追加
        currData.push(productId);
        isRepetition = false;
    }
    var storageData = {
        productIds: currData,
        timestamp: currentTime,
    };

    // 存入 localStorage
    localStorage.setItem(type + "Product", JSON.stringify(storageData));
    // 返回是否重复
    return isRepetition;
}

// 获取当前时间
const getCurrentDateTime = () => {
    const now = new Date(); // 当前时间
    const year = now.getUTCFullYear(); // UTC 年
    const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // UTC 月（+1）
    const day = String(now.getUTCDate()).padStart(2, "0"); // UTC 日
    const hours = String(now.getUTCHours()).padStart(2, "0"); // UTC 小时
    const minutes = String(now.getUTCMinutes()).padStart(2, "0"); // UTC 分钟
    const seconds = String(now.getUTCSeconds()).padStart(2, "0"); // UTC 秒
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
};
// 获取未来某分钟数后的时间
const getFutureDateTime = (minutesToAdd) => {
    const now = new Date(); // 当前时间
    now.setUTCMinutes(now.getUTCMinutes() + minutesToAdd); // 增加指定的分钟数
    const year = now.getUTCFullYear(); // UTC 年
    const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // UTC 月（+1）
    const day = String(now.getUTCDate()).padStart(2, "0"); // UTC 日
    const hours = String(now.getUTCHours()).padStart(2, "0"); // UTC 小时
    const minutes = String(now.getUTCMinutes()).padStart(2, "0"); // UTC 分钟
    const seconds = String(now.getUTCSeconds()).padStart(2, "0"); // UTC 秒
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
};
// 获取时间戳
function getTimestamp() {
    return Date.now();
}

// 调用cart接口发送订单
function sendCart(items) {

    // 如果购物车为空，则刷新页面
    if (items.items.length == 0) {
        location.href = location.href;
        return;
    }

    // 如果存在，执行追踪事件
    var initiateCheckoutData = {
        currency: items.currency,
        value: items.total_price,
        contents: []
    }
    for (let i = 0; i < items.items.length; i++) {

        const newItem = {
            id: items.items[i].product_id,
            quantity: items.items[i].quantity
        };

        initiateCheckoutData.contents.push(newItem);
    }


    if (typeof fbq === 'function' || typeof window.fbq === 'function') {

        fbq('track', 'InitiateCheckout', initiateCheckoutData);

    } else if (typeof sendEvent === 'function' || typeof window.sendEvent === 'function') {

        sendEvent('InitiateCheckout', 'track', initiateCheckoutData);

    }

    // 获取pid
    var pids = getCookieValue("pid");
    var pidStr = "";
    if (pids) {
        pidStr = "?pid=" + pids;
    }

    // 获取 _fbp, _fbc, ttclid 三个值
    const fbp = getCookieValue("_fbp");
    const fbc = getCookieValue("_fbc");
    const ttclid = getCookieValue("ttclid");
    const url = window.location.href;
    items.fbp = fbp || null;
    items.fbc = fbc || null;
    items.ttclid = ttclid || null;
    items.url = url || null;

    // 构建发送请求的 data
    const data = JSON.stringify(items);

    // 发送请求
    fetch("https://goho.work/api/Order/Cart" + pidStr, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include", // 发送跨域请求时包含Cookie
        body: data,
    })
        .then((response) => response.json())
        .then((res) => {
            // 只有返回状态为 OK，才更新缓存
            if (res.Succeeded) {
                // 成功
                // loading 关
                //updateLoadingStatus(false);

                // 成功则清空购物车
                //clearCartData();
                // 处理url
                location.href = res.Data;
            } else {
                // loading 关
                updateLoadingStatus(false);
                console.error("接口返回失败:", res);
                // 刷新页面
                location.reload();
            }
        })
        .catch((error) => {
            // loading 关
            updateLoadingStatus(false);
            console.error("提交失败:", error);
        });
}

// 异步函数，用于获取购物车数据
async function fetchCartData() {
    try {
        // 修改并设置 localization cookie 为 USD
        document.cookie = "localization=US; path=/"; // 设置 cookie，有效范围为整个网站

        const timestamp = getTimestamp();
        const response = await fetch(`/cart.js?t=${timestamp}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Cookie: "localization=US",
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        const cartData = await response.json(); // 解析返回的 JSON 数据
        return cartData; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 清空购物车数据
async function clearCartData() {
    try {
        const response = await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        const cartData = await response.json(); // 解析返回的 JSON 数据
        return cartData; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 添加购物车数据
async function addCartData(skuId, quantity) {
    try {
        const data = {
            items: [
                {
                    id: skuId, // skuid
                    quantity: quantity, // 数量
                },
            ],
        };
        const response = await fetch("cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        return response; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 商品详情页执行逻辑
if (window.location.pathname.includes("/products/")) {
    // 获取商品详情页面的数据
    const productId = document.querySelector("[name='product-id']").value;

    // 判断fir是否存在
    if (!getCookieValue("fir")) {
        // 获取pid
        var pids = getCookieValue("pid");
        if (pids && !pids.includes(productId)) {
            // 已存在，且不重复，则拼接
            pids += `,${productId}`;
        } else {
            // 不存在则设置
            pids = productId;
        }

        // 有效期为一天
        setCookieValue("pid", pids, getFutureDateTime(24 * 60));
    }

    // 判断缓存中是否重复，如果重复则不做接口提交
    var isRepetition = updateLocalStorageByType(productId, "click");
    if (!isRepetition) {
        const productIdArray = [productId];

        // 发送商品详情页点击请求
        const currentDomain = window.location.hostname;
        sendProductIdsToBackend(
            currentDomain,
            productIdArray,
            "Click",
            productIdArray
        );
    }

    // 添加购物车按钮

    // 获取表单中的按钮元素
    const addButton = document.querySelector(".atc-button.product-form__submit.button.button--full-width.button--margin-x.main-product-atc");
    // 确保按钮存在并且是有效的
    if (addButton) {
        // 监听按钮点击事件
        addButton.addEventListener("click", function (event) {
            //event.preventDefault(); // 防止表单提交

            const productId = document.querySelector("[name='product-id']").value;

            // 判断缓存中是否重复，如果重复则不做接口提交
            var isRepetition = updateLocalStorageByType(productId, "addToCart");
            if (!isRepetition) {
                const inputValueArray = [productId];
                const domain = window.location.hostname;
                sendProductIdsToBackend(
                    domain,
                    inputValueArray,
                    "AddToCart",
                    inputValueArray
                );
            }
        });
    }
}

// 购物车页执行逻辑
if (window.location.pathname.includes("/cart")) {
    // 获取指定 ID 的结算按钮
    const cartButton = document.getElementById("checkout");

    if (cartButton) {
        cartButton.addEventListener("click", async (event) => {
            event.preventDefault(); // 防止表单提交
            event.stopImmediatePropagation(); // 阻止其他点击事件

            // loading 开
            updateLoadingStatus(true);

            // 获取购物车数据
            const cartData = await fetchCartData();

            // 请求结算接口
            sendCart(cartData);
        });
    }
}

// 分类商品页逻辑
if (window.location.pathname.includes("/collections/")) {
    // 限定在 .pagination-wrapper 内查找分页链接
    const paginationWrapper = document.querySelector(".pagination-wrapper");
    if (paginationWrapper) {
        const paginationLinks = paginationWrapper.querySelectorAll(
            "a.pagination__item.link, a.pagination__item--next, a.pagination__item--prev"
        );

        // 通用处理函数
        function handlePaginationClick(event) {
            event.preventDefault();

            const originalHref = this.getAttribute("href");
            if (!originalHref) return;

            // 清除 ?q=xxx 或 &q=xxx
            let cleanedHref = originalHref
                .replace(/([&?])q=[^&]+/, "")
                .replace(/(&|\?)$/, "");

            // 如果剩下的参数以 & 开头，改成 ?
            if (cleanedHref.includes("&") && !cleanedHref.includes("?")) {
                cleanedHref = cleanedHref.replace("&", "?");
            }

            // 跳转
            window.location.href = cleanedHref;
        }

        // 添加事件监听
        paginationLinks.forEach((link) => {
            link.addEventListener("click", handlePaginationClick);
        });
    }
}


// 定义一个函数来检查滚动深度并发送事件给Facebook Pixel
function trackScrollDepth() {
    var scrollThresholds = [25, 50, 75];
    // 设置滚动阈值
    var eventsSent = {};
    // 用于记录已经发送的事件，避免重复发送
    window.addEventListener("scroll", function () {
        if (typeof fbq === "function") {
            // 检查fbq是否是一个函数
            var docHeight = document.documentElement.scrollHeight;
            var scrollPosition =
                window.pageYOffset !== undefined
                    ? window.pageYOffset
                    : (
                        document.documentElement ||
                        document.body.parentNode ||
                        document.body
                    ).scrollTop;
            var viewportHeight =
                window.innerHeight || document.documentElement.clientHeight;
            var scrollDepth = Math.round(
                ((scrollPosition + viewportHeight) * 100) / docHeight
            );
            scrollThresholds.forEach(function (threshold) {
                if (scrollDepth >= threshold && !eventsSent[threshold]) {
                    // 发送包含滚动深度百分比的自定义事件
                    fbq("track", "ScrollDepth", { sd: threshold });
                    console.log("threshold：" + threshold);
                    eventsSent[threshold] = true;
                    // 标记该事件已被发送
                }
            });
            // 如果用户已经滚动到了页面底部，则触发100%的事件
            if (scrollDepth >= 100 && !eventsSent[100]) {
                fbq("track", "ScrollDepth", { sd: 100 });
                console.log("threshold：" + 100);
                eventsSent[100] = true;
            }
        }
    });
}
// 定义一个函数来定期发送页面停留时长事件
function trackPageDuration() {
    var startTime = Date.now();
    var intervalId; // 定时器 ID
    var maxDuration = 200; // 最大停留时间（200秒）
    var isSubmitted = false; // 标记是否已经提交事件
    // 记录页面加载的时间
    var intervalId;
    function sendDurationEvent() {
        if (typeof fbq === "function") {
            // 检查fbq是否是一个函数
            var elapsedTime = Math.floor((Date.now() - startTime) / 1000);
            // 如果停留时间已经超过200秒，则停止提交并关闭监听
            if (elapsedTime >= maxDuration && !isSubmitted) {
                fbq("track", "PageDuration", { dur: elapsedTime });
                console.log("Max：" + elapsedTime);
                clearInterval(intervalId); // 清除定时器
                isSubmitted = true; // 标记事件已提交
            } else if (!isSubmitted) {
                fbq("track", "PageDuration", { dur: elapsedTime });
                console.log("elapsedTime：" + elapsedTime);
            }
        }
    }
    // 页面加载完成后立即发送第一次事件
    sendDurationEvent();
    // 每隔10秒发送一次更新的停留时间
    intervalId = setInterval(sendDurationEvent, 10000);
    // 当用户离开页面时清除定时器
    window.addEventListener("beforeunload", function () {
        clearInterval(intervalId);
        // 在用户离开前最后一次发送停留时间
        sendDurationEvent();
    });
}
// 页面加载完成后调用这两个函数
window.onload = function () {
    trackScrollDepth();
    trackPageDuration();
};

// 设置fir的cookie ，有效期20分钟
setCookieValue("fir", "1", getFutureDateTime(20));
